import { SVGProps, Ref, forwardRef } from 'react';

export const ClockOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.733 16c0-3.31.833-6.363 2.652-8.547 1.756-2.107 4.692-3.72 9.615-3.72s7.859 1.613 9.615 3.72c1.82 2.184 2.652 5.237 2.652 8.547s-.832 6.363-2.652 8.547c-1.756 2.107-4.692 3.72-9.615 3.72s-7.859-1.613-9.615-3.72C4.565 22.363 3.733 19.31 3.733 16m-2.4 0C1.333 8.667 5 1.333 16 1.333S30.667 8.667 30.667 16 27 30.667 16 30.667 1.333 23.333 1.333 16m15.867-.706V7.467h-2.4v9.24l7.666 4.258 1.166-2.098z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ClockOutlinedSize32Glyph.displayName = 'ClockOutlinedSize32Glyph';
